import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {termsOfUseURL} from "../../constants/api/endpoints";
import {backendBaseUrl} from "../../constants/api/backendBaseUrl";

export const useGetTermsOfUse = () => {

  const handleRequest = async () => {
    const {data} = await axios.get(backendBaseUrl + termsOfUseURL);
    return data;
  }

  return useQuery({
    queryKey: ['terms-of-use'],
    queryFn: handleRequest
  });
}